<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><a id="page-vii"></a><span class="center"><em>In memory of Billy M. and that</em></span></p>
<p class="center"><span class="center"><em>Second Street kitchen of swag</em></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?04ce0abc